import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useTheme, alpha } from "@mui/material/styles";
import MDTypography from "components/MDTypography";

/**
 * Card-style selectable option matching MD / MUI design system.
 */
export default function OptionCard({ selected, onClick, label, sublabel, disabled }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <Box
      component="button"
      type="button"
      disabled={disabled}
      onClick={onClick}
      sx={{
        width: "100%",
        textAlign: "left",
        cursor: disabled ? "not-allowed" : "pointer",
        border: "1px solid",
        borderColor: selected ? primary : theme.palette.divider,
        borderRadius: 3,
        px: 2,
        py: 1.75,
        bgcolor: selected ? alpha(primary, theme.palette.mode === "dark" ? 0.18 : 0.08) : "background.paper",
        boxShadow: selected ? `0 4px 14px ${alpha(primary, 0.22)}` : theme.shadows[1],
        transition: "border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, transform 0.15s ease",
        "&:hover": disabled
          ? {}
          : {
              borderColor: primary,
              bgcolor: alpha(primary, theme.palette.mode === "dark" ? 0.12 : 0.06),
              boxShadow: theme.shadows[3],
              transform: "translateY(-1px)",
            },
        "&:focus-visible": {
          outline: `2px solid ${primary}`,
          outlineOffset: 2,
        },
      }}
    >
      <MDTypography variant="button" fontWeight={selected ? 700 : 600} color="text.primary" sx={{ display: "block" }}>
        {label}
      </MDTypography>
      {sublabel ? (
        <MDTypography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.25 }}>
          {sublabel}
        </MDTypography>
      ) : null}
    </Box>
  );
}

OptionCard.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  sublabel: PropTypes.node,
  disabled: PropTypes.bool,
};

OptionCard.defaultProps = {
  selected: false,
  sublabel: null,
  disabled: false,
};
